import { observable, action } from 'mobx';

export default class StatementStore {

  defaultParams = {
    selectedStatementStr: 'Current Month',
    selectedWalletStr: 'All Wallets',
    selectedStatement: 0,
    selectedWallet: 'All'
  };

  paramRestrict15Days = {
    selectedStatementStr: 'Last Week',
    selectedWalletStr: 'All Wallets',
    selectedStatement: 2,
    selectedWallet: 'All'
  };

  defaultStatementFilter = {
    statementType: '',
    date: '',
    wallet: '',
  };

  //Mobx store
  @observable selectedOptions = {
    selectedStatement: null,
    selectedWallet: null
  };

  @action
  updateSelectedNewOptions(data) {
    this.selectedOptions = data;
  }

  @observable statementFilter = this.defaultStatementFilter;

  @observable dataStatementTable = {
    statements: []
  };

  @observable statementPagination = {
    page: 1,
    total: 0,
    recordsPerPage: 20,
    hasMore: false
  };

  @observable dataStatementMenu = {
    activeWallets: [],
    defaultParams: this.defaultParams,
    paramRestrict15Days: this.paramRestrict15Days
  };

  @observable wagerDetails = {};

  @observable loadMoreCallback = null;

  @observable isUseStatementV2 = (window.env || {}).enableBonusWalletSeparation;

  @action
  setLoadMoreCallback(callback) {
    this.loadMoreCallback = callback;
  }

  @action
  triggerLoadMore() {
    if (this.loadMoreCallback) {
      this.loadMoreCallback();
    }
  }

  @action
  updateStatementFilter(filter) {
    this.statementFilter = filter;
  }

  @action
  resetStatementFilter() {
    this.statementFilter = this.defaultStatementFilter;
  }
  
  @action
  updateStatements(data) {
    this.dataStatementTable.statements = data;
  }

  @action
  appendStatements(newData) {
    this.dataStatementTable.statements = [...this.dataStatementTable.statements, ...newData];
  }

  @action
  updateStatementPagination(pagination) {
    const { page, total, recordsPerPage } = pagination;
    
    // Calculate hasMore correctly
    const hasMore = (page * recordsPerPage) < total;
    
    this.statementPagination = {
      page,
      total,
      recordsPerPage,
      hasMore
    };
  }

  @action
  resetStatementPagination() {
    this.statementPagination = {
      page: 1,
      total: 0,
      recordsPerPage: 20,
      hasMore: false
    };
  }

  @action
  updateActiveWallets(data) {
    this.dataStatementMenu.activeWallets = data;
  }

  @action
  updateWagerDetails(wagerId, details) {
    this.wagerDetails[wagerId] = details;
  }

  @action
  getWagerDetails(wagerId) {
    return this.wagerDetails[wagerId];
  }

  @action setIsUseStatementV2(value) {
    this.isUseStatementV2 = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/StatementStore.js